import script from "./erp.vue?vue&type=script&setup=true&lang=js"
export * from "./erp.vue?vue&type=script&setup=true&lang=js"

import "./erp.vue?vue&type=style&index=0&id=94ad77b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94ad77b8"]])

export default __exports__